// extracted by mini-css-extract-plugin
export var label = "_gi-0";
export var treatmentCard = "_gi-1";